import { usePopup } from "../../context/PopupContext";
import OrderPlacedPopup from "./OrderPlacedPopup";

function GlobalPopup() {
  const { show, title, message } = usePopup();

  return <OrderPlacedPopup show={show} title={title} message={message} />;
}

export default GlobalPopup;
